module.exports = __webpack_public_path__ + "static/speed-roadmap-6bfe5fc781a8a5884291e3d311461dba.svg";